import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommChevronUpIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.6723 15.7657C17.976 16.0781 18.4685 16.0781 18.7722 15.7657C19.0759 15.4533 19.0759 14.9467 18.7722 14.6343L12.55 8.23431C12.2462 7.92189 11.7538 7.92189 11.45 8.23431L5.22781 14.6343C4.92407 14.9467 4.92407 15.4533 5.22781 15.7657C5.53155 16.0781 6.02401 16.0781 6.32775 15.7657L12 9.93137L17.6723 15.7657Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
